import { ResultRow } from "./types";

export const allowedParams: Array<string> = [ "car" ]

export const plateNumberRegex = new RegExp(/^[A-z]{3}-[0-9]{3}$/)
export const socialSecurityNumberRegex = new RegExp(/^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])([5-9]\d\+|\d\d-|[01]\dA)\d{3}[\dABCDEFHJKLMNPRSTUVWXY]$/gmi)
export const postalCodeRegex = new RegExp(/^.{5}$/)

export const annualMileageOptions = [
	{ id: 0, disabled: true },
	{ id: 4999, disabled: false },
	{ id: 9999, disabled: false },
	{ id: 14999, disabled: false },
	{ id: 19999, disabled: false },
	{ id: 24999, disabled: false },
	{ id: 29999, disabled: false },
	{ id: 34999, disabled: false },
	{ id: 35001, disabled: false },
	{ id: 99999, disabled: false },
]

export const vehicleTypeOptions = [
	{ id: "1", disabled: false },
	{ id: "2", disabled: true },
	{ id: "3", disabled: true },
]

export const getVehicleTypeOptions = (vehicleTypeTitles: any[]) => {
	let returnValues: Array<any> = []

	for ( const vehicleType of vehicleTypeTitles ) {
		const foundVehicleTypeOption = vehicleTypeOptions.find((option) => option.id === vehicleType.id)

		if ( foundVehicleTypeOption ) {
			returnValues.push({
				id: foundVehicleTypeOption.id,
				title: vehicleType.title,
				disabled: foundVehicleTypeOption.disabled,
			})
		}
	}

	return returnValues
}

export const getAnnualMileageOptions = (annualMileageTitles: any[]) => {
	let returnValues: Array<any> = []

	for ( const annualMileageOption of annualMileageTitles ) {
		const foundAnnualMileageOption = annualMileageOptions.find((option) => option.id === annualMileageOption.id)

		if ( foundAnnualMileageOption ) {
			returnValues.push({
				id: foundAnnualMileageOption.id,
				title: annualMileageOption.title,
				disabled: foundAnnualMileageOption.disabled,
			})
		}
	}

	return returnValues
}

export const partnerOptions = [
	{ id: "pop", title: "POP" },
]

export const levelOptions = [
	{ order: "0", id: "liikenne" },
	{ order: "1", id: "osakasko" },
	{ order: "2", id: "täyskasko" },
	{ order: "3", id: "kaikki" },
]

export const getLevelOptions = (levelOfCoverTitles: any[]) => {
	let returnValues: Array<any> = []

	for ( const level of levelOfCoverTitles ) {
		const foundLevelOption = levelOptions.find((option) => option.id === level.id)

		if ( foundLevelOption ) {
			returnValues.push({
				order: foundLevelOption.order,
				id: foundLevelOption.id,
				title: level.title,
			})
		}
	}

	return returnValues
}

export const includedOptions = [
	{ title: "Liikenne" },
	{ title: "Varkaus" },
	{ title: "Ilkivalta" },
	{ title: "Palo" },
	{ title: "Autopalvelu" },
]

export const getIncludedOptions = (level: string): { title: string }[] => {
	switch ( level ) {
		case "liikenne":
			return [
				{ title: "Liikenne" },
			]
		case "osakasko":
			return [
				{ title: "Liikenne" },
				{ title: "Oikeus" },
				{ title: "Ulkomaa" },
				{ title: "Palo" },
				// { title: "Hinaus" },
				// { title: "Ilkivalta" },
				{ title: "Varkaus" },
				// { title: "Hirvi" },
				{ title: "Eläin" },
			]
		case "täyskasko":
			return [
				{ title: "Liikenne" },
				{ title: "Oikeus" },
				{ title: "Ulkomaa" },
				{ title: "Palo" },
				{ title: "Hinaus" },
				{ title: "Ilkivalta" },
				{ title: "Varkaus" },
				// { title: "Hirvi" },
				{ title: "Eläin" },
				{ title: "Rahoitus" },
				{ title: "Kolari" },
				// { title: "Rengas" },
			]
		case "kaikki":
			return [
				// { title: "Liikenne" },
				{ title: "Oikeus" },
				{ title: "Ulkomaa" },
				{ title: "Palo" },
				{ title: "Hinaus" },
				{ title: "Ilkivalta" },
				{ title: "Varkaus" },
				{ title: "Eläin" },
				// { title: "Hirvi" },
				{ title: "Luonnonilmiö" },
				{ title: "Lasi" },
				{ title: "Kolari" },
				{ title: "Keskeytys" },
				{ title: "Lunastus" },
				{ title: "Pysäköinti" },
				// { title: "Rahoitus" },
				// { title: "Rengas" },
			]
		default:
			return []
	}
}

export const notIncludedOptions = [
	{ title: "Kolari" },
]

export const filterOptions = [
	{ id: "ulkomaanvastuu", title: "Ulkomaan vastuu" },
	{ id: "lasi", title: "Lasi" },
]

export const starOptions = [
	{ id: "4", amount: 4, amountLeft: 1 },
	{ id: "3", amount: 3, amountLeft: 2 },
]

export const coverCommonNamesMap: Map<string, string[]> = new Map([
	[ "Liikenne", [ "Liikennevakuutus", "Liikennevahinko" ] ],
	[ "Oikeus", [ "Oikeusturva", "Oikeusturvavakuutus" ] ],
	[ "Ulkomaa", [ "Ulkomaan vastuu", "Ulkomaan vastuuturva", "Moottoriajoneuvon ulkomaan vastuuvakuutus" ] ],
	[ "Palo", [ "Paloturva", "Palo", "Palovakuutus" ] ],
	[ "Hinaus", [ "Hinausturva" ] ],
	[ "Ilkivalta", [ "Ilkivaltaturva", "Ilkivalta", "Ilkivaltavakuutus" ] ],
	[ "Varkaus", [ "Varkausturva", "Varkaus", "Varkausvakuutus" ] ],
	[ "Hirvi", [ "Hirvivahinko", "Eläintörmäysturva", "Hirvivahinkovakuutus" ] ],
	[ "Eläin", [ "Eläintörmäysturva", "Eläin", "Eläinvahinko", "Eläinvahinkovakuutus" ] ],
	[ "Rahoitus", [ "Rahoitusturva", "Rahoitus", "Osamaksu- ja leasingvakuutus" ] ],
	[ "Luonnonilmiö", [ "Luonnonilmiöturva", "Luonnonilmiö", "Luonnonilmiövakuutus" ] ],
	[ "Lasi", [ "Lasiturva", "Lasi", "Lasivakuutus", "Lasiturva, omavastuu 0 € tai 150 €" ] ],
	[ "Kolari", [ "Kolariturva", "Törmäys", "Kolarivakuutus" ] ],
	[ "Rengas", [ "Rengasturva", "Rengasturva, omavastuu 50 €" ] ],
	[ "Keskeytys", [ "Matkan jatkuminen", "Keskeytys", "Keskeytysvakuutus", "Matkan jatkuminen, omavastuu 0 €" ] ],
	[ "Lunastus", [ "Lunastusturva", "Laaja lunastus" ] ],
	[ "Pysäköinti", [ "Parkkiturva", "Pysäköinti", "Pysäköintivakuutus" ] ]
])

const commonNameTranslations = [
	{
		id: "Autopalvelu",
		title: "Autopalvelu",
		titleEN: "Car service",
	},
	{
		id: "Osakasko",
		title: "Osakasko",
		titleEN: "Partial insurance",
	},
	{
		id: "Täyskasko",
		title: "Täyskasko",
		titleEN: "Full insurance",
	},
	{
		id: "Kaskovakuutus",
		title: "Kaskovakuutus",
		titleEN: "Fully insurance",
	},
	{
		id: "Laaja vuokra-auto",
		title: "Laaja vuokra-auto",
		titleEN: "Comprehensive rental car",
	},
	{
		id: "Vastuuturva",
		title: "Vastuuturva",
		titleEN: "Liability protection",
	},
	{
		id: "Liikenne",
		title: "Liikenne",
		titleEN: "Traffic",
	},
	{
		id: "Oikeus",
		title: "Oikeusturva",
		titleEN: "Legal protection",
	},
	{
		id: "Ulkomaa",
		title: "Ulkomaan vastuu",
		titleEN: "Foreign liability",
	},
	{
		id: "Palo",
		title: "Paloturva",
		titleEN: "Fire protection",
	},
	{
		id: "Hinaus",
		title: "Hinausturva",
		titleEN: "Towing protection",
	},
	{
		id: "Ilkivalta",
		title: "Ilkivaltaturva",
		titleEN: "Vandalism protection",
	},
	{
		id: "Varkaus",
		title: "Varkausturva",
		titleEN: "Theft protection",
	},
	{
		id: "Hirvi",
		title: "Hirvivahinko",
		titleEN: "Moose damage",
	},
	{
		id: "Eläin",
		title: "Eläintörmäysturva",
		titleEN: "Animal collision protection",
	},
	{
		id: "Rahoitus",
		title: "Rahoitusturva",
		titleEN: "Financing protection",
	},
	{
		id: "Luonnonilmiö",
		title: "Luonnonilmiöturva",
		titleEN: "Natural phenomenon protection",
	},
	{
		id: "Lasi",
		title: "Lasiturva",
		titleEN: "Glass protection",
	},
	{
		id: "Kolari",
		title: "Kolariturva",
		titleEN: "Collision protection",
	},
	{
		id: "Rengas",
		title: "Rengasturva",
		titleEN: "Tire protection",
	},
	{
		id: "Keskeytys",
		title: "Matkan jatkuminen",
		titleEN: "Continuation of the journey",
	},
	{
		id: "Lunastus",
		title: "Lunastusturva",
		titleEN: "Redemption protection",
	},
	{
		id: "Pysäköinti",
		title: "Parkkiturva",
		titleEN: "Parking protection"
	}
]

export const getVisibleValue = (commonName: string, language: string): string => {
	const foundCommonName = commonNameTranslations.find((translation) => translation.id === commonName)

	if ( foundCommonName ) {
		if ( language === "en" ) {
			return foundCommonName.titleEN
		} else {
			return foundCommonName.title
		}
	}

	return commonName
}

export const getCompanyDescription = (companyName: string): string => {
	let returnValue: string = ""

	switch (companyName) {
		case "Fennia":
			returnValue = "Fennia on kotimainen vakuutusyhtiö, joka on tunnettu erityisesti pk-yritysten ja yrittäjien vakuuttajana, mutta tarjoaa myös kilpailukykyisiä ratkaisuja yksityisasiakkaille. Yhtiö korostaa selkeyttä ja läpinäkyvyyttä vakuutuspaketeissaan, ja sen hinnoittelu on usein houkutteleva erityisesti kokonaistarjouksissa. Fennian asiakaspalvelu saa kiitosta henkilökohtaisuudestaan ja nopeasta reagoinnistaan Fennia tarjoaa kolme tasoa kaskovakuutuksia: osakasko, laajakasko ja täyskasko. Fennian paketit ovat selkeitä, helposti vertailtavia ja hyvin hinnoiteltuja. Voit myös lisätä turvia tarpeen mukaan, kuten sijaisauton, lasivakuutuksen ja eläinkolariturvan. Fennian bonusjärjestelmä on kilpailukykyinen, ja bonukset säilyvät hyvin verrattuna moniin muihin yhtiöihin."
			break
		case "LähiTapiola":
			returnValue = "LähiTapiola on asiakasomisteinen yhtiö, joka yhdistää vakuuttamisen ja terveyden edistämisen. Se tarjoaa asiakkailleen muun muassa TerveysHelppi-palvelun, joka nopeuttaa hoitoon pääsyä vahinkotilanteissa. Yhtiö panostaa vahvasti asiakaskokemukseen ja tarjoaa laajan valikoiman räätälöitäviä vakuutuksia, joita voi täydentää lisäturvilla auton käyttöön ja elämäntilanteeseen sopiviksi. LähiTapiola tarjoaa useita kaskotyyppejä (osa-, laaja- ja täyskasko), joita voi täydentää hyödyllisillä lisäturvilla, kuten hinausturvalla, sijaisautolla, eläinkolariturvalla ja lasivakuutuksella. S-ryhmän Bonukset ja keskittämisedut tekevät LähiTapiolasta houkuttelevan vaihtoehdon erityisesti S-Etukortin haltijoille."
			break
		case "Pohjantähti":
			returnValue = "Pohjantähti on riippumaton ja kotimainen vakuutusyhtiö, joka panostaa henkilökohtaiseen asiakaspalveluun. Jokaiselle asiakkaalle nimetään oma yhteyshenkilö, mikä tekee asioinnista sujuvaa ja yksilöllistä. Yhtiö tarjoaa selkeitä ja muokattavia vakuutusratkaisuja, jotka sopivat erityisesti niille, jotka arvostavat kotimaisuutta ja pitkäaikaista asiakassuhdetta. Pohjantähti tarjoaa kilpailukykyisellä lähtöbonuksella liikennevakuutuksen ja useita kaskovaihtoehtoja, kuten osakasko, laaja kasko ja superkasko. Vakuutukseen voi liittää lisäturvia, kuten lasivakuutuksen, hinausturvan, eläinkolariturvan ja sijaisautopalvelun. Vakuutus voidaan räätälöidä omien tarpeidesi ja auton iän mukaan."
			break
		case "Pohjola Vakuutus":
			returnValue = "Pohjola Vakuutus on osa OP Ryhmää, joka on yksi Suomen suurimmista finanssikonserneista. Yhtiö tunnetaan erityisesti pankki- ja vakuutuspalveluiden yhdistämisestä, mikä mahdollistaa asiakkaille keskittämisetujen hyödyntämisen. OP:n omistaja-asiakkaat saavat OP-bonuksia, joita voi käyttää vakuutusmaksuihin, mikä tekee vakuutuksista houkuttelevia erityisesti niille, joilla on myös pankkipalvelut OP:ssa. Pohjola Vakuutus tarjoaa autovakuutuksia, jotka ovat erityisen houkuttelevia OP:n asiakkaille ja keskittäjille. OP-bonukset vakuutusmaksujen maksamiseen tekevät vakuutuksesta käytännössä edullisemman, varsinkin jos sinulla on myös pankkipalvelut OP:ssa. Lisäksi useiden vakuutusten keskittäminen Pohjolaan tuo tuntuvia alennuksia autovakuutuksesta."
			break
		case "POP":
			returnValue = "POP Vakuutus on moderni ja digitaalisesti ketterä vakuutusyhtiö, joka tunnetaan erityisesti edullisista hinnoistaan ja suoraviivaisista vakuutusratkaisuistaan. Se palvelee asiakkaita pääosin verkossa, mikä mahdollistaa nopeat tarjoukset ja helpon asioinnin. POPin kaskovaihtoehdot ovat selkeitä ja helposti vertailtavia, ja yhtiö tarjoaa houkuttelevia lisäturvia, kuten lunastusturvan ja parkkiturvan, erityisesti vähän ajaville autoilijoille. POP Vakuutus tarjoaa edullisia kaskovaihtoehtoja, kuten XL, L ja S -tasot, sekä lisäturvia, kuten parkkiturvan, lunastusturvan, rengasturvan ja matkan jatkumisen turvan. Hyvät bonukset ovat saatavilla myös kakkosautolle, ja alennuksia myönnetään turvallisesta ajosta tai ajokoulutuksesta."
			break
		case "Turva":
			returnValue = "Turva on suomalainen vakuutusyhtiö, joka toimii tiiviissä yhteistyössä ammattiliittojen kanssa. Se tarjoaa liittojäsenille räätälöityjä etuja, kuten alennuksia ja lisäturvia ilman lisämaksua. Turva profiloituu vahvasti yhteisölliseksi ja asiakaslähtöiseksi toimijaksi, joka ymmärtää erityisesti julkisen sektorin työntekijöiden tarpeita ja arkea. Turva tarjoaa eri tasoisia kaskovakuutuksia, kuten osakasko, laajakasko ja täyskasko, joihin voi liittää lisäturvia, kuten hinaus- ja matkaturvan, lasiturvan, eläinkolariturvan ja sijaisautopalvelun. Ammattiliittoalennukset ja jäsenedut tekevät Turvasta erityisen edullisen liittojäsenille."
			break
		default:
			returnValue = ""
			break
	}

	return returnValue
}

export const companyHasDeal = (companyId: string | undefined): boolean => {
	let returnValue: boolean = false;

	switch (companyId) {
		case "POP":
			returnValue = true;
			break
		default:
			returnValue = false;
	}

	return returnValue
}

export const getResultCountForLevelOfCover = (levelOfCover: string, results: ResultRow[]): number => {
	let returnValue = 0

	if ( levelOfCover === "Liikennevakuutus" ) levelOfCover = "Liikenne"

	if ( results.length > 0 ) {
		for ( const resultRow of results ) {
			if ( resultRow.group === levelOfCover || levelOfCover === "Kaikki" ) returnValue++
		}
	}

	return returnValue
}

export const placeholderResults: Array<ResultRow> = [
	{
		"group": "Liikenne",
		"price": "1,180.00",
		"priceValue": 1180.00,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 0
		},
		"quoteId": 63762,
		"matrixId": 76,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Liikennevahinko"
			}
		],
		"productName": "Liikennevakuutus",
		"insuranceCompany": {
			"url": "https://www.pohjantahti.fi/vakuutukset/autovakuutus/",
			"name": "Pohjola-Vakuutus"
		}
	},
	{
		"group": "Liikenne",
		"price": "509.52",
		"priceValue": 509.52,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 78.5
		},
		"quoteId": 63750,
		"matrixId": 89,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			}
		],
		"productName": "Liikennevakuutus omavastuu 0 €",
		"insuranceCompany": {
			"url": "https://www.turva.fi/henkiloasiakkaat/vakuutukset/autovakuutus",
			"name": "Turva"
		}
	},
	{
		"group": "Liikenne",
		"price": "998.60",
		"priceValue": 998.60,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 73
		},
		"quoteId": 63743,
		"matrixId": 94,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			}
		],
		"productName": "Liikennevakuutus",
		"insuranceCompany": {
			"url": "https://www.lahitapiola.fi/henkilo/vakuutukset-ja-elake/autot-ja-veneet",
			"name": "LähiTapiola"
		}
	},
	{
		"group": "Liikenne",
		"price": "722.97",
		"priceValue": 722.97,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 75.2
		},
		"quoteId": 63737,
		"matrixId": 71,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			}
		],
		"productName": "Liikennevakuutus",
		"insuranceCompany": {
			"url": "https://www.popvakuutus.fi/vakuutukset/autovakuutus",
			"name": "POP"
		}
	},
	{
		"group": "Osakasko",
		"price": "1,350.72",
		"priceValue": 1350.72,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 0
		},
		"quoteId": 63761,
		"matrixId": 77,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Kaskovakuutus"
			},
			{
				"name": "Liikennevahinko"
			},
			{
				"name": "Eläin"
			},
			{
				"name": "Varkaus"
			},
			{
				"name": "Palo"
			},
			{
				"name": "Autopalvelu"
			},
			{
				"name": "Oikeusturva"
			}
		],
		"productName": "Malttikasko",
		"insuranceCompany": {
			"url": "https://www.pohjantahti.fi/vakuutukset/autovakuutus/",
			"name": "Pohjantähti"
		}
	},
	{
		"group": "Osakasko",
		"price": "1,491.32",
		"priceValue": 1491.32,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 0
		},
		"quoteId": 63760,
		"matrixId": 80,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Kaskovakuutus"
			},
			{
				"name": "Liikennevahinko"
			},
			{
				"name": "Eläin"
			},
			{
				"name": "Varkaus"
			},
			{
				"name": "Palo"
			},
			{
				"name": "Autopalvelu"
			},
			{
				"name": "Oikeusturva"
			}
		],
		"productName": "Malttikasko (lisäturvilla)",
		"insuranceCompany": {
			"url": "https://www.pohjantahti.fi/vakuutukset/autovakuutus/",
			"name": "Pohjantähti"
		}
	},
	{
		"group": "Osakasko",
		"price": "713.48",
		"priceValue": 713.48,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 78.5
		},
		"quoteId": 63752,
		"matrixId": 92,
		"coverages": [
			{
				"name": "Eläintörmäysturva"
			},
			{
				"name": "Hirvivahinkoturva"
			},
			{
				"name": "Paloturva"
			},
			{
				"name": "Varkausturva"
			},
			{
				"name": "Ilkivaltaturva"
			},
			{
				"name": "Oikeusturva"
			},
			{
				"name": "Ulkomaan vastuuturva"
			},
			{
				"name": "Autopalveluturva"
			}
		],
		"productName": "Hirvi, ilkivalta, palo ja varkaus omavastuu 200 euroa",
		"insuranceCompany": {
			"url": "https://www.turva.fi/henkiloasiakkaat/vakuutukset/autovakuutus",
			"name": "Turva"
		}
	},
	{
		"group": "Osakasko",
		"price": "1,610.23",
		"priceValue": 1610.23,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 73
		},
		"quoteId": 63742,
		"matrixId": 97,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Autopalveluvakuutus"
			},
			{
				"name": "Eläintörmäysvakuutus"
			},
			{
				"name": "Hirvivahinkovakuutus"
			},
			{
				"name": "Ilkivaltavakuutus"
			},
			{
				"name": "Oikeusturvavakuutus"
			},
			{
				"name": "Palovakuutus"
			},
			{
				"name": "Ulkomaan vastuuvakuutus "
			},
			{
				"name": "Varkausvakuutus"
			}
		],
		"productName": "Osakasko (lisäturvilla)",
		"insuranceCompany": {
			"url": "https://www.lahitapiola.fi/henkilo/vakuutukset-ja-elake/autot-ja-veneet",
			"name": "LähiTapiola"
		}
	},
	{
		"group": "Osakasko",
		"price": "1,292.72",
		"priceValue": 1292.72,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 73
		},
		"quoteId": 63741,
		"matrixId": 95,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Autopalveluvakuutus"
			},
			{
				"name": "Eläintörmäysvakuutus"
			},
			{
				"name": "Hirvivahinkovakuutus"
			},
			{
				"name": "Ilkivaltavakuutus"
			},
			{
				"name": "Oikeusturvavakuutus"
			},
			{
				"name": "Palovakuutus"
			},
			{
				"name": "Ulkomaan vastuuvakuutus "
			},
			{
				"name": "Varkausvakuutus"
			}
		],
		"productName": "Osakasko",
		"insuranceCompany": {
			"url": "https://www.lahitapiola.fi/henkilo/vakuutukset-ja-elake/autot-ja-veneet",
			"name": "LähiTapiola"
		}
	},
	{
		"group": "Osakasko",
		"price": "882.37",
		"priceValue": 882.37,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [],
			"insurerepsi": 75.2
		},
		"quoteId": 63738,
		"matrixId": 68,
		"coverages": [
			{
				"name": "Oikeusturva"
			},
			{
				"name": "Hinausturva"
			},
			{
				"name": "Vastuuturva"
			},
			{
				"name": "Ilkivaltaturva"
			},
			{
				"name": "Varkausturva"
			},
			{
				"name": "Paloturva"
			},
			{
				"name": "Eläintörmäysturva"
			},
			{
				"name": "Ulkomaan vastuuturva"
			},
			{
				"name": "Liikennevakuutus"
			}
		],
		"productName": "S-kasko",
		"insuranceCompany": {
			"url": "https://www.popvakuutus.fi/vakuutukset/autovakuutus",
			"name": "POP"
		}
	},
	{
		"group": "Täyskasko",
		"price": "2,289.03",
		"priceValue": 2289.03,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakuutusyhtiön kattava täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii yli 3v vanhoille autoille"
				}
			],
			"insurerepsi": 0
		},
		"quoteId": 63759,
		"matrixId": 82,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Kaskovakuutus"
			},
			{
				"name": "Liikennevahinko"
			},
			{
				"name": "Törmäys"
			},
			{
				"name": "Luonnonilmiö"
			},
			{
				"name": "Eläin"
			},
			{
				"name": "Ilkivalta"
			},
			{
				"name": "Varkaus"
			},
			{
				"name": "Palo"
			},
			{
				"name": "Autopalvelu"
			},
			{
				"name": "Oikeusturva"
			}
		],
		"productName": "Luottokasko (lisäturvilla)",
		"insuranceCompany": {
			"url": "https://www.pohjantahti.fi/vakuutukset/autovakuutus/",
			"name": "Pohjantähti"
		}
	},
	{
		"group": "Täyskasko",
		"price": "2,430.41",
		"priceValue": 2430.41,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakutuusyhtiön kattavin täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii uusille autoille"
				}
			],
			"insurerepsi": 0
		},
		"quoteId": 63758,
		"matrixId": 81,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Kaskovakuutus"
			},
			{
				"name": "Liikennevahinko"
			},
			{
				"name": "Törmäys"
			},
			{
				"name": "Luonnonilmiö"
			},
			{
				"name": "Eläin"
			},
			{
				"name": "Ilkivalta"
			},
			{
				"name": "Varkaus"
			},
			{
				"name": "Palo"
			},
			{
				"name": "Autopalvelu"
			},
			{
				"name": "Oikeusturva"
			}
		],
		"productName": "Luottokasko (kaikki lisäturvilla)",
		"insuranceCompany": {
			"url": "https://www.pohjantahti.fi/vakuutukset/autovakuutus/",
			"name": "Pohjantähti"
		}
	},
	{
		"group": "Täyskasko",
		"price": "1,862.74",
		"priceValue": 1862.74,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakutuusyhtiön suppein täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii vanhemmille autoille"
				}
			],
			"insurerepsi": 0
		},
		"quoteId": 63757,
		"matrixId": 78,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Kaskovakuutus"
			},
			{
				"name": "Liikennevahinko"
			},
			{
				"name": "Törmäys"
			},
			{
				"name": "Luonnonilmiö"
			},
			{
				"name": "Eläin"
			},
			{
				"name": "Ilkivalta"
			},
			{
				"name": "Varkaus"
			},
			{
				"name": "Palo"
			},
			{
				"name": "Autopalvelu"
			},
			{
				"name": "Oikeusturva"
			}
		],
		"productName": "Luottokasko",
		"insuranceCompany": {
			"url": "https://www.pohjantahti.fi/vakuutukset/autovakuutus/",
			"name": "Pohjantähti"
		}
	},
	{
		"group": "Täyskasko",
		"price": "2,124.62",
		"priceValue": 2124.62,
		"addons": [
			{
				"name": "Lasi",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Keskeytys",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Lunastusturva",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Eläinvahinko",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Luonnonilmiö",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Pysäköinti",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Laaja vuokra-auto",
				"price": null,
				"optional": false,
				"selected": true
			}
		],
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakuutusyhtiön kattava täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii yli 3v vanhoille autoille"
				}
			],
			"insurerepsi": 72.1
		},
		"quoteId": 63756,
		"matrixId": 79,
		"coverages": [
			{
				"name": "Liikenne"
			},
			{
				"name": "Kolari"
			},
			{
				"name": "Hirvivahinko"
			},
			{
				"name": "Ilkivalta"
			},
			{
				"name": "Palo"
			},
			{
				"name": "Varkaus"
			},
			{
				"name": "Autopalvelu"
			},
			{
				"name": "Oikeusturva"
			},
			{
				"name": "Ulkomaan vastuu"
			}
		],
		"productName": "Liikennevakuutus ja Laaja Fenniakasko (lisäturvilla)",
		"insuranceCompany": {
			"url": "https://www.fennia.fi/ajoneuvot",
			"name": "Fennia"
		}
	},
	{
		"group": "Täyskasko",
		"price": "2,192.55",
		"priceValue": 2192.55,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakutuusyhtiön kattavin täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii uusille autoille"
				}
			],
			"insurerepsi": 72.1
		},
		"quoteId": 63755,
		"matrixId": 74,
		"coverages": [
			{
				"name": "Liikenne"
			},
			{
				"name": "Kolari"
			},
			{
				"name": "Hirvivahinko"
			},
			{
				"name": "Ilkivalta"
			},
			{
				"name": "Palo"
			},
			{
				"name": "Varkaus"
			},
			{
				"name": "Autopalvelu"
			},
			{
				"name": "Oikeusturva"
			},
			{
				"name": "Lasi"
			},
			{
				"name": "Ulkomaan vastuu"
			},
			{
				"name": "Lunastusturva"
			},
			{
				"name": "Eläinvahinko"
			},
			{
				"name": "Luonnonilmiö"
			},
			{
				"name": "Pysäköinti"
			},
			{
				"name": "Laaja vuokra-auto"
			}
		],
		"productName": "Liikennevakuutus ja Premiumkasko",
		"insuranceCompany": {
			"url": "https://www.fennia.fi/ajoneuvot",
			"name": "Fennia"
		}
	},
	{
		"group": "Täyskasko",
		"price": "1,810.71",
		"priceValue": 1810.71,
		"addons": [
			{
				"name": "Lasi",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Keskeytys",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Lunastusturva",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Eläinvahinko",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Luonnonilmiö",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Pysäköinti",
				"price": null,
				"optional": false,
				"selected": true
			},
			{
				"name": "Laaja vuokra-auto",
				"price": null,
				"optional": false,
				"selected": true
			}
		],
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakutuusyhtiön suppein täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii vanhemmille autoille"
				}
			],
			"insurerepsi": 72.1
		},
		"quoteId": 63754,
		"matrixId": 75,
		"coverages": [
			{
				"name": "Liikenne"
			},
			{
				"name": "Kolari"
			},
			{
				"name": "Hirvivahinko"
			},
			{
				"name": "Ilkivalta"
			},
			{
				"name": "Palo"
			},
			{
				"name": "Varkaus"
			},
			{
				"name": "Autopalvelu"
			},
			{
				"name": "Oikeusturva"
			},
			{
				"name": "Ulkomaan vastuu"
			}
		],
		"productName": "Liikennevakuutus ja Laaja Fenniakasko",
		"insuranceCompany": {
			"url": "https://www.fennia.fi/ajoneuvot",
			"name": "Fennia"
		}
	},
	{
		"group": "Täyskasko",
		"price": "1,358.27",
		"priceValue": 1358.27,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakutuusyhtiön kattavin täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii uusille autoille"
				}
			],
			"insurerepsi": 78.5
		},
		"quoteId": 63751,
		"matrixId": 90,
		"coverages": [
			{
				"name": "Eläintörmäysturva"
			},
			{
				"name": "Hirvivahinkoturva"
			},
			{
				"name": "Paloturva"
			},
			{
				"name": "Varkausturva"
			},
			{
				"name": "Ilkivaltaturva"
			},
			{
				"name": "Oikeusturva"
			},
			{
				"name": "Ulkomaan vastuuturva"
			},
			{
				"name": "Autopalveluturva"
			},
			{
				"name": "Kolarointiturva"
			},
			{
				"name": "Luonnonilmiöturva"
			}
		],
		"productName": "Peruskasko omavastuu 200 euroa",
		"insuranceCompany": {
			"url": "https://www.turva.fi/henkiloasiakkaat/vakuutukset/autovakuutus",
			"name": "Turva"
		}
	},
	{
		"group": "Täyskasko",
		"price": "2,105.42",
		"priceValue": 2105.42,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakutuusyhtiön suppein täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii vanhemmille autoille"
				}
			],
			"insurerepsi": 73
		},
		"quoteId": 63744,
		"matrixId": 96,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Autopalveluvakuutus"
			},
			{
				"name": "Eläintörmäysvakuutus"
			},
			{
				"name": "Hirvivahinkovakuutus"
			},
			{
				"name": "Ilkivaltavakuutus"
			},
			{
				"name": "Kolarointivakuutus"
			},
			{
				"name": "Luonnonilmiövakuutus"
			},
			{
				"name": "Oikeusturvavakuutus"
			},
			{
				"name": "Palovakuutus"
			},
			{
				"name": "Ulkomaan vastuuvakuutus "
			},
			{
				"name": "Varkausvakuutus"
			}
		],
		"productName": "Peruskasko",
		"insuranceCompany": {
			"url": "https://www.lahitapiola.fi/henkilo/vakuutukset-ja-elake/autot-ja-veneet",
			"name": "LähiTapiola"
		}
	},
	{
		"group": "Täyskasko",
		"price": "2,847.00",
		"priceValue": 2847.00,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakuutusyhtiön kattava täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii yli 3v vanhoille autoille"
				}
			],
			"insurerepsi": 73
		},
		"quoteId": 63740,
		"matrixId": 98,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Autopalveluvakuutus"
			},
			{
				"name": "Eläintörmäysvakuutus"
			},
			{
				"name": "Hirvivahinkovakuutus"
			},
			{
				"name": "Ilkivaltavakuutus"
			},
			{
				"name": "Kolarointivakuutus"
			},
			{
				"name": "Lasivakuutus"
			},
			{
				"name": "Lunastusetuvakuutus"
			},
			{
				"name": "Luonnonilmiövakuutus"
			},
			{
				"name": "Oikeusturvavakuutus"
			},
			{
				"name": "Palovakuutus"
			},
			{
				"name": "Pysäköintivakuutus"
			},
			{
				"name": "Ulkomaan vastuuvakuutus "
			},
			{
				"name": "Varkausvakuutus"
			}
		],
		"productName": "Laaja Kasko (lisäturvilla)",
		"insuranceCompany": {
			"url": "https://www.lahitapiola.fi/henkilo/vakuutukset-ja-elake/autot-ja-veneet",
			"name": "LähiTapiola"
		}
	},
	{
		"group": "Täyskasko",
		"price": "3,086.06",
		"priceValue": 3086.06,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakutuusyhtiön kattavin täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii uusille autoille"
				}
			],
			"insurerepsi": 73
		},
		"quoteId": 63739,
		"matrixId": 99,
		"coverages": [
			{
				"name": "Liikennevakuutus"
			},
			{
				"name": "Autopalveluvakuutus"
			},
			{
				"name": "Eläintörmäysvakuutus"
			},
			{
				"name": "Hirvivahinkovakuutus"
			},
			{
				"name": "Ilkivaltavakuutus"
			},
			{
				"name": "Kolarointivakuutus"
			},
			{
				"name": "Laaja sijaisautovakuutus"
			},
			{
				"name": "Lasivakuutus"
			},
			{
				"name": "Lunastusetuvakuutus"
			},
			{
				"name": "Luonnonilmiövakuutus"
			},
			{
				"name": "Oikeusturvavakuutus"
			},
			{
				"name": "Palovakuutus"
			},
			{
				"name": "Pysäköintivakuutus"
			},
			{
				"name": "Ulkomaan vastuuvakuutus "
			},
			{
				"name": "Varkausvakuutus"
			}
		],
		"productName": "Loistokasko (kaikki lisäturvilla)",
		"insuranceCompany": {
			"url": "https://www.lahitapiola.fi/henkilo/vakuutukset-ja-elake/autot-ja-veneet",
			"name": "LähiTapiola"
		}
	},
	{
		"group": "Täyskasko",
		"price": "1,670.34",
		"priceValue": 1670.34,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakuutusyhtiön kattava täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii yli 3v vanhoille autoille"
				}
			],
			"insurerepsi": 75.2
		},
		"quoteId": 63736,
		"matrixId": 69,
		"coverages": [
			{
				"name": "Rahoitusturva"
			},
			{
				"name": "Luonnonilmiöturva"
			},
			{
				"name": "Lasiturva, omavastuu 0 € tai 150 €"
			},
			{
				"name": "Kolariturva"
			},
			{
				"name": "Oikeusturva"
			},
			{
				"name": "Hinausturva"
			},
			{
				"name": "Vastuuturva"
			},
			{
				"name": "Ilkivaltaturva"
			},
			{
				"name": "Varkausturva"
			},
			{
				"name": "Paloturva"
			},
			{
				"name": "Eläintörmäysturva"
			},
			{
				"name": "Ulkomaan vastuuturva"
			},
			{
				"name": "Liikennevakuutus"
			}
		],
		"productName": "L-kasko",
		"insuranceCompany": {
			"url": "https://www.popvakuutus.fi/vakuutukset/autovakuutus",
			"name": "POP"
		}
	},
	{
		"group": "Täyskasko",
		"price": "1,971.67",
		"priceValue": 1971.67,
		"addons": null,
		"rating": {
			"epsi": 74.6,
			"negative": [],
			"positive": [
				{
					"icon": 1,
					"note": "Vakutuusyhtiön kattavin täyskasko"
				},
				{
					"icon": 1,
					"note": "Sopii uusille autoille"
				}
			],
			"insurerepsi": 75.2
		},
		"quoteId": 63735,
		"matrixId": 70,
		"coverages": [
			{
				"name": "Lunastusturva"
			},
			{
				"name": "Parkkiturva"
			},
			{
				"name": "Matkan jatkuminen, omavastuu 0 €"
			},
			{
				"name": "Rengasturva, omavastuu 50 €"
			},
			{
				"name": "Rahoitusturva"
			},
			{
				"name": "Luonnonilmiöturva"
			},
			{
				"name": "Lasiturva, omavastuu 0 € tai 150 €"
			},
			{
				"name": "Kolariturva"
			},
			{
				"name": "Oikeusturva"
			},
			{
				"name": "Hinausturva"
			},
			{
				"name": "Vastuuturva"
			},
			{
				"name": "Ilkivaltaturva"
			},
			{
				"name": "Varkausturva"
			},
			{
				"name": "Paloturva"
			},
			{
				"name": "Eläintörmäysturva"
			},
			{
				"name": "Ulkomaan vastuuturva"
			},
			{
				"name": "Liikennevakuutus"
			}
		],
		"productName": "XL-kasko",
		"insuranceCompany": {
			"url": "https://www.popvakuutus.fi/vakuutukset/autovakuutus",
			"name": "POP"
		}
	}
]

export const getProductName = (productName: string, language: string): string => {
	let returnValue: string = productName

	if ( productName.includes(" (lisäturvilla)") ) {
		returnValue = productName.replace(" (lisäturvilla)", "")
	} else if ( productName.includes(" (kaikki lisäturvilla)") ) {
		returnValue = productName.replace(" (kaikki lisäturvilla)", "")
	}

	return returnValue
}
